export interface User {
  id?: number;
  userIdNo?: number;
  displayName?: string;
  email?: string;
  userTypeCode?: string;
  platformTenantCode?: string;
}


/**
 * The RequiredUserAccountAction enum represents the actions that a user may be required to perform on their account, such as updating their password or verifying their email address. The UserAccount interface defines the structure of a user account object, which includes an array of permissions and an array of required actions.
 */
export enum RequiredUserAccountAction {
  UPDATE_PASSWORD = 'UPDATE_PASSWORD',
  VERIFY_EMAIL = 'VERIFY_EMAIL',
}
export interface UserAccount {
  permissions: string[];
  requiredActions: RequiredUserAccountAction[];
}
